<div class="-{{ type }}">
  <ng-content></ng-content>
</div>
